<template lang="pug">
  .lista-solicitud.contenedor-interno
    .modal.is-active(:class="{'modal-sidebar-desktop-open': showSidebarDesktop }", v-if="mostrarConfirmacionGestionar")
      .modal-background(@click="mostrarConfirmacionGestionar = false")
      transition(name='fade-quick')
        confirmar-accion-overlay(
            @close="mostrarConfirmacionGestionar = false"
            @do="gestionarRenovacion"
            ref="confirmarGestionar"
          )
            span(slot="title") ¿Desea indicar que ya se realizo la renovación?
            span(slot="primaryAction")
              template(v-if="isSending")
                | Confirmando...
              template(v-else)
                | Confirmar
    .title
      span Solicitudes aprobadas
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close

    .indicaciones
      .title
        span Datos a tener en cuenta
      ul.list
        li.list-item
          span Solo aparecen las solicitudes de renovación aprobadas por la gerencia
        li.list-item
          span Gestione la renovación de contrato
        li.list-item
          span La solicitud desaparecerá de la lista, cuando se envíe la información desde el sistema de planillas

    div.contenedor-fechas-boton
      div
        p Fecha fin de contrato
        div
            input.input(
              type="date",
              v-model="fechaFinContrato",
            )
      div.padding-left-20
        .boton-container
          button.button.is-primary(@click="fetch")
            span.icon.is-small
              i.fa.fa-refresh.fa-fw.fa-lg
            span Refrescar

    .body
      table.table.is-striped.is-bordered(v-if="!isLoading")
        thead
          th Empleado
          th.hide-break-1 Tipo renovación
          th Estado
          th Creado por
          th.hide-break-1 Fecha vencimiento
          th.hide-break-1
        tbody(
          name="table-row"
          is="transition-group"
        )
          tr.row-table(
            v-for="(o,index) in lista"
            :key="o+index+''"
          )
            td
              .hint--top(:aria-label="'Empleado: ' + o.codigo")
                span.hint--bottom(:aria-label="'ID: ' + o.id") {{ o.nombre }}
                br
                .show-break-1
                  span.has-text-bold Renovacion:
                  br
                  span(v-if="o.indeterminado") Contrato Indeterminado
                  span(v-else) {{ o.meses }} meses
            td.hide-break-1
              span(v-if="o.indeterminado") Contrato Indeterminado
              span(v-else) {{ o.meses }} meses
            td {{ o.descripcionEstado }}
            td
              span {{ o.creadoPor }}
              br
              .show-break-1
                span.has-text-bold Vencimiento:
                br
                span {{ o.fechaFinContrato }}
                br
                .button.is-small.is-info.mt-5(@click="confirmacionYaSeGestiono(o)")
                  span.icon.is-small
                    i.fa.fa-check.fa-fw.fa-lg
                  span Ya se gestionó
            td.hide-break-1 {{ o.fechaFinContrato }}
            td.hide-break-1
              .contenedor-acciones
                .button.is-small.is-info(@click="confirmacionYaSeGestiono(o)")
                  span.icon.is-small
                    i.fa.fa-check.fa-fw.fa-lg
                  span Ya se gestionó
      loading(v-if="isLoading")
</template>

<script>
import { apiGet, apiPost, notify } from '../util/general'
import ConfirmarAccionOverlayComponent from './Component_Confirmar_Accion_Overlay'

export default {
  name: 'lista_solicitud_vacaciones_aprobadas_component',
  components: {
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  data () {
    return {
      fechaFinContrato : '',
      lista: [],
      isLoading: true,
      mostrarConfirmacionGestionar: false,
      solicitud:{
        id: 0
      }
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  methods: {
    confirmacionYaSeGestiono (item) {
      var vm = this;
      vm.mostrarConfirmacionGestionar = true
      vm.solicitud.id = item.id
    },
    gestionarRenovacion () {
      var vm = this
      var obj = { ...vm.solicitud }
      apiPost(vm, '/contratos/lo-tomo', obj, function (data) {
        notify(vm, 'success', 'Éxito', data.message)
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.fetch();
        vm.mostrarConfirmacionGestionar = false
      })
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {
        fechaFinContrato : vm.fechaFinContrato
      }
      apiGet(vm, '/contratos/solicitud/aprobadas', obj, function (data) {
        if (data.lista.length === 0) {
          vm.$emit('close')
        }

        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important

  .contenedor-acciones
    display flex
    .button
      flex 1
      margin 0px 5px



  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }


  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    width: 300px;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .quitar
    margin-left 5px
    cursor pointer
    i
      font-size 15px

  .indicaciones
    flex 1
    padding 10px
    border 1px solid #209cee
    color: #12537e;
    background-color #f6fbfe
    display flex
    flex-direction column
    margin 10px

    strong
      color #209cee

    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 21px
      margin-bottom 5px

    .list
      display flex
      flex-direction column
      justify-content center
      flex 1
      text-align left
      .list-item
        padding-left 10px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold
  .boton-container
    button
      margin-left 5px
  .contenedor-fechas-boton
    display: flex;
    flex-direction: inherit;
    align-items: center;
    justify-content: center;
    padding-bottom: 15px;
  .padding-left-20
    padding-left: 20px;

  .show-break-1
    display none

  @media (max-width 875px)
    .show-break-1
      display initial
    .hide-break-1
      display none
    .table
      font-size 12px
</style>



// WEBPACK FOOTER //
// Component_Contratos_Lista_Solicitud_Renovacion_Contrato_Aprobadas.vue?02041ae1